/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Catholic_Theology22Inputs */

const en__field__enum_studyprograms_study_catholic_theology22 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Catholic_Theology22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catholic Theology`)
};

const de__field__enum_studyprograms_study_catholic_theology22 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Catholic_Theology22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katholische Theologie`)
};

/**
* | output |
* | --- |
* | "Catholic Theology" |
*
* @param {_Field__Enum_Studyprograms_Study_Catholic_Theology22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_catholic_theology22 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Catholic_Theology22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Catholic_Theology22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_catholic_theology22(inputs)
	return de__field__enum_studyprograms_study_catholic_theology22(inputs)
});
export { _field__enum_studyprograms_study_catholic_theology22 as "_field__enum_studyPrograms_STUDY_CATHOLIC_THEOLOGY" }